var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBusinessTransactionsDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4585 2.50202V1.04602H12.3405V0.0460205H7.57457V1.04602H9.45855V2.50202C7.18972 2.63215 5.06101 3.64168 3.52458 5.31616C1.98815 6.99065 1.16506 9.19816 1.23015 11.4698C1.29524 13.7414 2.24338 15.8982 3.87317 17.4819C5.50296 19.0657 7.68599 19.9517 9.95855 19.9517C12.2311 19.9517 14.4141 19.0657 16.0439 17.4819C17.6737 15.8982 18.6219 13.7414 18.687 11.4698C18.752 9.19816 17.929 6.99065 16.3925 5.31616C14.8561 3.64168 12.7274 2.63215 10.4586 2.50202H10.4585ZM11.7585 9.73402H9.12457V10.742H11.7585V13.708L10.3105 13.706V14.77H9.30854V13.706L8.12457 13.704V12.704L10.7586 12.706V11.742L8.12457 11.744V8.73402H9.44053V7.67202H10.4425V8.73402H11.7585L11.7585 9.73402Z",
    fill: "#C61E1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7227 2.37981L16.0156 3.08691L18.0657 5.13696L18.7728 4.42985L16.7227 2.37981Z",
    fill: "#C61E1E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBusinessTransactionsDebit);
export default __webpack_public_path__ + "static/media/business-transactions-debit.65776f57.svg";
export { ForwardRef as ReactComponent };